<template>
    <n-link
        :to="getPath(balloonData.id)"
        :class="['offices-list-item pointer flex justify-between', type]"
    >
        <div class="ol-content">
            <div class="">
                <h4
                    v-if="balloonData.title"
                    class="ol-content__title"
                >
                    {{ balloonData.title }}
                </h4>
                <p class="ol-content__address text">
                    <span v-if="balloonData.address">{{ balloonData.city.title }}, {{ balloonData.address }}</span>
                    <span v-else>{{ getFormattedAddress(balloonData.address_full) }}</span>
                </p>
                <p
                    v-if="balloonData.work_time"
                    class="ol-content__working text"
                >
                    <span class="ol-content__working-client mb-6">Частным клиентам</span>
                    <span v-html="balloonData.work_time" />
                </p>
                <p
                    v-if="balloonData.work_time_legal_entities"
                    class="ol-content__working text"
                >
                    <span class="ol-content__working-client mb-6">Юридическим лицам</span>
                    <span v-html="balloonData.work_time_legal_entities" />
                </p>
                <p
                    v-if="balloonData.work_time_vip"
                    class="ol-content__working text"
                >
                    <span class="ol-content__working-client mb-6">VIP Обслуживание</span>
                    <span v-html="balloonData.work_time_vip" />
                </p>
                <p
                    v-if="balloonData.work_time_bio_data_collection"
                    class="ol-content__working text"
                >
                    <span class="ol-content__working-client mb-6">сбор биометрии</span>
                    <span v-html="balloonData.work_time_bio_data_collection" />
                </p>
                <template v-if="balloonData.temporaryNotices.length">
                    <p
                        v-for="(notice, index) in balloonData.temporaryNotices"
                        :key="`notice__${index}`"
                        class="text text-light text-red mb-16"
                    >
                        {{ notice }}
                    </p>
                </template>
            </div>
            <UIButton
                v-if="isRemoteOfficeAvailable(balloonData)"
                size="xs"
                label="Записаться на посещение офиса"
                @click.stop="onConfirmRemoteOfficeRecording(balloonData)"
            />
        </div>
    </n-link>
</template>

<script>
import {defineComponent} from 'vue';
import {UIButton} from '@cibsite/ui-components-vue2';

import {useOfficeRemoteEntry} from '@/core/composables/useOfficeRemoteEntry';

export default defineComponent({
    name: 'OfficesListItem',
    components: {
        UIButton,
    },
    props: {
        balloonData: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const {
            isRemoteOfficeAvailable,
            onConfirmRemoteOfficeRecording,
        } = useOfficeRemoteEntry();

        function getFormattedAddress(address) {
            return address.split(',').slice(1).join(',');
        }

        function getPath(id) {
            return `/about/offices-and-atms/${props.type}?id=${id}`;
        }

        return {
            isRemoteOfficeAvailable,
            onConfirmRemoteOfficeRecording,
            getPath,
            getFormattedAddress,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/about/offices/offices-list-item';
</style>
